// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"183":"9bde9d44","475":"f1732553","971":"f767877e"}[chunkId] + ".css";
};